import React from "react";
import ProjectBox from "./ProjectBox";
import QuizApp from "../images/QuizApp.png";
import Bookstore from "../images/Bookstore.png";
import DooCommerce from "../images/DooCommerce.png";
import DooChat from "../images/DooChat.png";

const projectsData = [
  {
    id: "doochat",
    title: "DooChat",
    image: DooChat,
    desc: "DooChat is a real-time chat and mini social media platform where users can send messages, images, and videos, add friends, and engage in one-on-one conversations.",
    tags: ["Next.js", "Node.js", "Shadcn UI", "Socket.io"],
    github: "",
    demo: "https://doochat.io.vn/",
    status: "live",
  },
  {
    id: "quizapp",
    title: "QuizApp",
    image: QuizApp,
    desc: "QuizApp is an interactive quiz platform where users can take quizzes and receive scores based on their performance. The admin panel allows administrators to manage quizzes, questions, and users.",
    tags: ["React", "Material UI", "JavaScript"],
    github: "https://github.com/trungcrbay/QuizApp",
    demo: "https://quiz-app-trungcrbay.vercel.app/",
    status: "live",
  },
  {
    id: "bookstore",
    title: "BookStore",
    image: Bookstore,
    desc: "BookStore is an online book-selling website with two main sections: an admin panel for managing books, categories, and orders, and a client side where users can browse and purchase books.",
    tags: ["React", "Ant Design", "REST API"],
    github: "https://github.com/trungcrbay/React_ANTD_ECOMMERCE",
    demo: "https://react-antd-ecommerce.vercel.app/",
    status: "live",
  },
  {
    id: "doocommerce",
    title: "DooCommerce",
    image: DooCommerce,
    desc: "DooCommerce is a full-featured e-commerce web application that allows users to browse products, add items to their cart, place orders, and manage their profiles. Admins can manage products, categories, orders, and users.",
    tags: ["Next.js", "NestJS", "PostgreSQL"],
    github: "https://trungcrbay.io.vn/",
    demo: "",
    status: "ongoing",
  },
];

const Projects = () => {
  return (
    <div>
      <h1 className="projectHeading">
        My <b>Projects</b>
      </h1>
      <div className="project">
        {projectsData.map((project) => (
          <ProjectBox
            key={project.id}
            title={project.title}
            desc={project.desc}
            image={project.image}
            tags={project.tags}
            github={project.github}
            demo={project.demo}
            status={project.status}
          />
        ))}
      </div>
    </div>
  );
};

export default Projects;
